import { apiDaInscricao } from './axios';

export const obterQuestoesDoFormulario = async () => {

  const { data: questoesDoFormulario } = await apiDaInscricao().get('/questoesDoFormulario/obterTodas');

  return questoesDoFormulario;  
};